import axios from "axios";
import { CORREIOS_API_SERVER } from "../configs/constants";

const correios = axios.create({
  baseURL: CORREIOS_API_SERVER,
});

export default correios;
